import { useEffect, useState } from "react"
// import { useSession, signIn, signOut } from "next-auth/react";

// import GoogleLogin from "react-google-login";
import { useAuth } from "../../app/hooks/useAuth"
import {
  validateEmailOrReturnError
} from "../../utils/formatters"

export const ForgotPasswordForm = () => {
  const { forgotPassword, isLoading } = useAuth();
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");

  const [userFormValues, setUserFormValues] = useState({
    email: "",
    password: "",
  });

  const { email, password } = userFormValues;

  useEffect(() => {
    if (emailError) setEmailError("");
  }, [email]);

  useEffect(() => {
    if (passwordError) setPasswordError("");
  }, [password]);

  const handleChange = ({ target: { value, id } }) => {
    setUserFormValues({ ...userFormValues, [id]: value });
  };

  const validateEmail = (val) => {
    const validEmail = validateEmailOrReturnError(val);

    if (validEmail) {
      setEmailError(validEmail);
    } else {
      setEmailError("");
    }
  };

  const isValid = () => {
    validateEmail(email);
    return emailError === "";
  };

  const handleForgotPassword = async (e) => {
    analytics.track("forgot_password_button_clicked");
    e.preventDefault();
    if (userFormValues.email) {
      await forgotPassword(userFormValues.email);
    }
  };

  return (
    <div className="login-box">
      <div className="justify-center space-y-6">
        <h1 className="text-center text-2xl leading-6 font-bold mb-7">
          Forgot Password
        </h1>
        <div className="space-y-2 text-left">
          <div>
            <div className="space-y-4">
              <div className="input-label-text">E-mail</div>
              <input
                id="email"
                type="email"
                value={email}
                className="input-box"
                onChange={handleChange}
                onBlur={(e) => validateEmail(e.target.value)}
              />
            </div>

            <div className="text-sm text-primary-red h-5 mt-1">
              {emailError}
            </div>
          </div>
        </div>
        {/* {resultStatus && (
          <div className="text-sm text-primary-red text-center h-5 mt-2">
            {resultStatus}
          </div>
        )} */}
        <div className="flex justify-between items-center">
          <button
            className="flex items-center justify-center solid py-4 w-full bg-price-green btn font-semibold text-sm leading-3.5 text-black"
            onClick={handleForgotPassword}
          >
            <div>Send Link</div>
            {isLoading && (
              <svg
                className="animate-spin  h-5 w-5 text-white ml-4 absolute"
                style={{ left: "54%" }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
          </button>
        </div>
        <div>
          <a
            href="/login"
            className="text-sm underline underline-offset-1 text-gray-text"
            onClick={() => analytics.track("back_to_login_clicked")}
          >
            Back to Login
          </a>
        </div>
        {/* <div>
          <p className="text-sm underline underline-offset-1 text-gray-text text-left">
            Don't you have an account?{" "}
            <a href="users/invite/a" className="text-blue-600 text-base font-bold">
              Sign Up
            </a>
          </p>
        </div> */}
      </div>
    </div>
  );
};
